import axios, { AxiosResponse } from 'axios';

export const sendFormData = async (formData: IHubspotFormConfig): Promise<AxiosResponse> => {
  return await axios.post<IHubspotFormConfig>(
    'https://forms.hubspot.com/uploads/form/v2/5053292/9662202f-c536-4704-a357-cacb01d4863d',
    formData,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
    }
  );
};

export interface IHubspotFormConfig {
  average_hourly_bill_rate: string;
  email: string;
  revcap_annual_revenue: string;
  revcap_hours_week: string;
  revcap_nonbill_headcount: string;
  revcap_potential: string;
  revcap_pto_year: string;
  target_billable_utilization__assuming_a_40_hours__100: string;
  total_billable_headcount: string;
}
